import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=719bbba1&scoped=true"
import script from "./roleList.vue?vue&type=script&lang=js"
export * from "./roleList.vue?vue&type=script&lang=js"
import style0 from "./roleList.vue?vue&type=style&index=0&id=719bbba1&prod&scoped=scoped&lang=css"
import style1 from "./roleList.vue?vue&type=style&index=1&id=719bbba1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719bbba1",
  null
  
)

export default component.exports